import './Footer.css'
export default function Footer(params) {
 return(
    <>
    <footer style={{backgroundColor:"#f0f2f5"}}>
    </footer>
    </>
 )
    
}